<template>
 <div>
   <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />      
 <v-layout wrap pl-lg-4 pl-sm-3>
      <v-flex xs12 py-5>
        <div class="RM clr">SELLER PORTAL</div>
        <div class="head">Previous Order</div>
      </v-flex>
         <v-flex xs12>
            <v-card flat>
              <v-layout wrap v-for="(item, i) in orderData" :key="i" py-2>
                <v-flex xs12 sm2 md1 pb-3 pb-md-0>
                  <v-img
                  v-if="$vuetify.breakpoint.name == 'xs' ? 'height=90% ; width =90%' : 'height=100px ; width =100px'"
                    cover
                    :src="mediaURL + item.productId.photos[0]"
                  >
                  </v-img>
                </v-flex>
                <v-flex xs10 align-self-center pl-sm-3>
                  <v-layout wrap pl-lg-3>
                    <v-flex xs6 sm3 md2>
                      <div class="medium clr RG">Product Name</div>
                      <div class="RB medium">{{item.name}}</div>
                    </v-flex>
                    <v-flex xs3 sm2 md2 pt-sm-0 pt-md-0>
                      <div class="medium clr RG">Price</div>
                      <div class="RB medium">₹{{item.price}}/-</div>
                    </v-flex>
                     <v-flex xs3 sm2 md2>
                      <div class="medium clr RG">Sold Qty</div>
                      <div class="RB medium" >{{item.quantity}}</div>
                    </v-flex>
                     <v-flex xs3 sm2 md2 pt-4 pt-sm-0>
                     <div class="medium clr RG">Total</div>
                      <div class="RB medium" >{{item.productTotalAmount}}</div>
                    </v-flex>
                     <v-flex xs5 sm2 pt-4 pt-sm-0 >
                     <div class="medium clr RG">Date</div>
                      <div class="RB medium" >{{DateFormatted(item.order_date)}}</div>
                    </v-flex>
                    <v-flex xs4 sm4 md2 pt-4 pt-sm-0 pt-md-0 >
                      <div class="medium clr RG">Order Status</div>
                      <div class="RB medium">{{item.productOrderStatus}}</div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 pt-4>
                  <v-divider> </v-divider>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
 </v-layout>
 </div>
</template>
<script>
import axios from "axios"
import moment from "moment"
export default {
    data()
    {
        return{
          orderData:[],
          appLoading :false,
        }
    },
    mounted()
    {
    this.orderList();
    },
    methods:
    {
         DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y") : "";
    },
         orderList()
    {
        this.appLoading =true;
      axios({
        method: "post",
        url: "/seller/ordered/products/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
      .then((response)=>{
        if(response.data.status)
        {
         this.orderData = response.data.data      
        }
        this.appLoading =false;
      })
    }
    }
}
</script>